import { IApiGetDemoDataParam, IApiGetLibraryMediaParam, ILink, IListLibraryMediaResponse } from '../interfaces/api';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import apis from './apis';
import actions from './actions';
import { AxiosResponse } from 'axios';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { ISagaFunc } from 'services/actionConfigs';
import { setPageLoading } from 'widgets/PageLoading';
import { IResponseData } from 'services/response';
import { PaginationResponse } from 'services/commonTypes';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  } finally {
  }
};

const getListLibraryMedia: ISagaFunc<{ path: string, keySearch?: string }> = function* ({ payload}) {
  yield delay(200);
  try {
    const resData: IResponseData<{ data: IListLibraryMediaResponse }> = yield call(apis.getListLibraryMedia, payload.path, payload.keySearch);
    if (resData?.data?.data) {
      yield put(actions.getListLibraryMedia.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListLibraryMedia.fail({}));
  } finally {
  }
};

const getLibraryLinks: ISagaFunc<IApiGetLibraryMediaParam> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<PaginationResponse<ILink>> = yield call(apis.getLibraryLinks, payload);
    if (resData?.data?.data) {
      yield put(actions.getLibraryLinks.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getLibraryLinks.fail({}));
  } finally {
    setPageLoading(false);
  }
};

const getAllFoldersInStore: ISagaFunc<{ storeId: string }> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<{ data: IListLibraryMediaResponse }> = yield call(apis.getAllFoldersInStore, payload.storeId);
    if (resData?.data?.data) {
      yield put(actions.getAllFoldersInStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getAllFoldersInStore.fail({}));
  } finally {
    setPageLoading(false);
  }
};

export default function* mediaServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListLibraryMedia.fetch, getListLibraryMedia);
  yield takeLatest(actions.getLibraryLinks.fetch, getLibraryLinks);
  yield takeLatest(actions.getAllFoldersInStore.fetch, getAllFoldersInStore);
}
